import { selectors, actions } from 'app-webtech-core';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { SECTION_SELECT } from 'app-webtech-core/modules/layout/actions/types';
import { TRACK_EVENTS, SESSION_RESET } from './types';

const sessionResetAction = actionCreator(SESSION_RESET);
const sectionSelectAction = actionCreator(SECTION_SELECT);
const stopTrackingAction = actionCreator(TRACK_EVENTS);

export const playbackSessionSessionResetAction = ({ action, oldSessionID }) => (
  dispatch,
  getState,
) => {
  const state = getState();
  dispatch(
    stopTrackingAction({
      trackChannelEvents: false,
      trackClipEvents: false,
    }),
  );

  // to reset previousChannelId field
  dispatch(actions.guide.setPrevContentKind({ prevContentKind: null }));

  // to reset previousSection field
  const { section } = selectors.layout.properties(state);
  dispatch(
    sectionSelectAction({
      section,
      previousSection: 'na',
      doNotTrack: true,
    }),
  );

  // init action
  dispatch(action);
  dispatch(sessionResetAction({ oldSessionID }));
};
